import { useEffect } from "react";
import DropOffCalendar from "../../components/leads/DropOff/DropOffCalendar";
import { usePageNameContext } from "../../contexts/PageTitleContext";



export default function DropOff() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Drop Off Leads",
      desc: "View and manage your drop off leads here",
    });
  }, []);

  return <DropOffCalendar />
}